var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-row",
        [
          _vm._l(_vm.users, function(user, indexUser) {
            return [
              _c("v-col", { key: user.passenger_id, attrs: { cols: "12" } }, [
                _c(
                  "fieldset",
                  { staticClass: "custom-fieldset" },
                  [
                    _c(
                      "legend",
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("travelService.chooseOfferForm.passenger")
                            ) +
                            " " +
                            _vm._s(indexUser + 1) +
                            " "
                        ),
                        !_vm.readonly
                          ? [
                              user.company_user_id &&
                              _vm.$store.getters.hasPermission(
                                "saveUserDataFromTravelService"
                              )
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "my-0 py-0",
                                                      attrs: {
                                                        icon: "",
                                                        disabled: !_vm.isUserDataDifferentFromUserProfile(
                                                          user
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.saveInUserProfile(
                                                            user
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "fa-cloud-upload-alt"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("global.saveInUserProfile")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              user.company_user_id
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "my-0 py-0",
                                                      attrs: {
                                                        icon: "",
                                                        disabled: !_vm.isUserDataDifferentFromUserProfile(
                                                          user
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.changedPassengerId(
                                                            user,
                                                            user.company_user_id
                                                          )
                                                        }
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "fa-cloud-download-alt"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.travelUserInlineForm.loadFromUserProfile"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { staticClass: "pa-1", attrs: { cols: "3" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                clearable: !_vm.readonly,
                                items: _vm.userList,
                                label: _vm.$t(
                                  "travelService.chooseOfferForm.delegationSystemUser"
                                ),
                                readonly: _vm.readonly
                              },
                              on: {
                                change: function(value) {
                                  return _vm.changedPassengerId(user, value)
                                }
                              },
                              model: {
                                value: user.company_user_id,
                                callback: function($$v) {
                                  _vm.$set(user, "company_user_id", $$v)
                                },
                                expression: "user.company_user_id"
                              }
                            })
                          ],
                          1
                        ),
                        user.company_user_id == null
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("user.name") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.name,
                                    callback: function($$v) {
                                      _vm.$set(user, "name", $$v)
                                    },
                                    expression: "user.name"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        user.company_user_id == null
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("user.surname") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.surname,
                                    callback: function($$v) {
                                      _vm.$set(user, "surname", $$v)
                                    },
                                    expression: "user.surname"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_middle_name_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label:
                                      _vm.$t(
                                        "settings.users.basicData.fields.middleName.name"
                                      ) + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.middle_name,
                                    callback: function($$v) {
                                      _vm.$set(user, "middle_name", $$v)
                                    },
                                    expression: "user.middle_name"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_document_number_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("user.documentNumber") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.document_number,
                                    callback: function($$v) {
                                      _vm.$set(user, "document_number", $$v)
                                    },
                                    expression: "user.document_number"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_document_expire_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                !_vm.readonly
                                  ? _c("date-picker", {
                                      attrs: {
                                        label:
                                          _vm.$t("user.documentExpire") + "*",
                                        model: user.document_expire,
                                        rules: [_vm.isRequired]
                                      },
                                      on: {
                                        "update:model": function($event) {
                                          return _vm.$set(
                                            user,
                                            "document_expire",
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.readonly
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label:
                                          _vm.$t("user.documentExpire") + "*",
                                        readonly: _vm.readonly
                                      },
                                      model: {
                                        value: user.document_expire,
                                        callback: function($$v) {
                                          _vm.$set(user, "document_expire", $$v)
                                        },
                                        expression: "user.document_expire"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_document_issue_place_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label:
                                      _vm.$t("global.documentIssuePlace") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.document_issue_place,
                                    callback: function($$v) {
                                      _vm.$set(
                                        user,
                                        "document_issue_place",
                                        $$v
                                      )
                                    },
                                    expression: "user.document_issue_place"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_phone_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("user.phone") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.phone,
                                    callback: function($$v) {
                                      _vm.$set(user, "phone", $$v)
                                    },
                                    expression: "user.phone"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_birth_date_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                !_vm.readonly
                                  ? _c("date-picker", {
                                      attrs: {
                                        label: _vm.$t("user.birthDate") + "*",
                                        model: user.birth_date,
                                        rules: [_vm.isRequired]
                                      },
                                      on: {
                                        "update:model": function($event) {
                                          return _vm.$set(
                                            user,
                                            "birth_date",
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.readonly
                                  ? _c("v-text-field", {
                                      attrs: {
                                        label: _vm.$t("user.birthDate") + "*",
                                        readonly: _vm.readonly
                                      },
                                      model: {
                                        value: user.birth_date,
                                        callback: function($$v) {
                                          _vm.$set(user, "birth_date", $$v)
                                        },
                                        expression: "user.birth_date"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_email_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("user.email") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired, _vm.emailValidation]
                                  },
                                  model: {
                                    value: user.email,
                                    callback: function($$v) {
                                      _vm.$set(user, "email", $$v)
                                    },
                                    expression: "user.email"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_nationality_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label:
                                      _vm.$t(
                                        "settings.users.basicData.fields.nationality.name"
                                      ) + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.nationality,
                                    callback: function($$v) {
                                      _vm.$set(user, "nationality", $$v)
                                    },
                                    expression: "user.nationality"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.requiredProps.is_residence_address_required
                          ? _c(
                              "v-col",
                              { staticClass: "pa-1", attrs: { cols: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label:
                                      _vm.$t("global.residenceAddress") + "*",
                                    readonly: _vm.readonly,
                                    rules: [_vm.isRequired]
                                  },
                                  model: {
                                    value: user.residence_address,
                                    callback: function($$v) {
                                      _vm.$set(user, "residence_address", $$v)
                                    },
                                    expression: "user.residence_address"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }